import * as Sentry from '@sentry/browser'
import {
  API_CREATE_CUSTOM_AND_EXTERNAL_ACCOUNT,
  API_GET_CUSTOM_STRIPE_API_KEY,
  API_GET_CUSTOM_VERIFICATION_LINK,
  API_GET_SHOP_STRIPE_BALANCE,
  GET_PAYOUT_DETAILS
} from '../constants'
import { sendGetRequest, sendPostRequest } from '../utils/apiService'
import store from '../utils/store'
import { decrypt } from '../utils/encryption'
import { getCurrentOrigin } from '../utils/getEnv'

export const getStripeCustomApiKey = async () => {
  const { companyId } = store.getState().user;
  try {
    const cryptedApiKEy = (
      await sendGetRequest(API_GET_CUSTOM_STRIPE_API_KEY(companyId), {}, {})
    )?.data;
    return decrypt(cryptedApiKEy);
  } catch (error) {
    Sentry.captureMessage(`Error from ${companyId} in getting stripe custom api key: ${error}`);
  }
}

export const getStripeData = async (shopId, isAllShops) => {
  try {
    const { data: balances } = await sendPostRequest(
      API_GET_SHOP_STRIPE_BALANCE,
      {
        shopId,
        isAllShops
      },
      {}
    );
    return balances;
  } catch (err) {
    Sentry.captureMessage(`Error from ${shopId} in getStripeData: ${err}`);
    return false;
  }
};

export const createCustomAndExternalAccount = async (token, accountId, last4, support) => {
  const { shopId } = store.getState().user;
  const { shop = {}, generalConfig = {} } = store.getState().firebaseRealTime;
  const { name, legal = {} } = shop;
  const { url } = generalConfig;
  try {
    await sendPostRequest(
      API_CREATE_CUSTOM_AND_EXTERNAL_ACCOUNT,
      {
        support,
        last4,
        token,
        accountId,
        shopId,
        name,
        legal,
        url
      },
      {}
    );
    return true;
  } catch (err) {
    Sentry.captureMessage(`Error from ${shopId} in create custom and external account: ${err}`);
    return false;
  }
};

export const createTokens = async (stripe, name, iban) => {
  try {
    const { token: tokenIban } = await stripe.createToken(iban, {
      currency: 'eur',
      account_holder_name: name,
      account_holder_type: 'company'
    });
    const { token: tokenAccount } = await stripe.createToken('account', {
      account: {
        company: {
          name
        },
        tos_shown_and_accepted: true
      }
    });
    return { tokenIban, tokenAccount };
  } catch (err) {
    Sentry.captureMessage(`Error for ${name} in createTokens: ${err}`);
    return false;
  }
};

export const getAccountLink = async () => {
  const { user, firebaseRealTime } = store.getState();
  const { shopId } = user;
  const { shop } = firebaseRealTime;
  const { servicePrice } = shop;
  const { customAccountId: account } = servicePrice;
  const dashboardUrl = getCurrentOrigin();
  try {
    const { data: link } = await sendPostRequest(
      API_GET_CUSTOM_VERIFICATION_LINK,
      {
        account,
        refresh_url: dashboardUrl,
        return_url: dashboardUrl,
        type: 'account_onboarding'
      },
      {}
    );
    return link;
  } catch (err) {
    Sentry.captureMessage(`Error from ${shopId} in getStripeData: ${err}`);
    return false;
  }
};
export const getStripeDetails = async (shopId, automatic, transactionId) => {
  try {
    const { data: details } = await sendPostRequest(
      GET_PAYOUT_DETAILS,
      {
        shopId, transactionId,
        automaticPayout: automatic
      },
      {}

    );
    return details;
  } catch (err) {
    Sentry.captureMessage(`Error from ${shopId} in getStripeDetails: ${err}`);
    return false;
  }
};